import { FileService } from 'projects/services/src/app/API/document/file.service';
import { Component, OnInit, Input, OnChanges, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-view-trainer-details',
	templateUrl: './view-trainer-details.component.html',
	styleUrls: ['./view-trainer-details.component.css']
})

export class ViewTrainerDetailsComponent implements OnInit, OnChanges {
	@Input() data;
	@Input() jobRole;
	@Input() typeOfResource;
	@Input() viewTrainer: EventEmitter<{}>;
	downloadLink: any;
	isCertified: any = 'No';
	qpCode: any;
	constructor(
		private fileService: FileService
	) {
	}

	ngOnInit() {
		if (this.viewTrainer) {
			this.viewTrainer.subscribe((data: any) => {
				this.data = data.trainer;
				if (this.data && this.data.trainerObj.jobRoles) {
					for (let i = 0; i < this.data.trainerObj.jobRoles.length; i++) {
						this.qpCode = this.jobRole.name ? this.jobRole.name.qpCode : this.jobRole.qp
						if (this.data.trainerObj.jobRoles[i].jobRoleId === this.qpCode && this.data.trainerObj.jobRoles[i].isCertified === true) {
							this.isCertified = this.data.trainerObj.jobRoles[i].isCertified === true ? 'Yes' : 'No';
							this.downloadLink = this.data.trainerObj.jobRoles[i].certificateDetails ?
								this.data.trainerObj.jobRoles[i].certificateDetails.certificateURLDetails ?
									this.data.trainerObj.jobRoles[i].certificateDetails.certificateURLDetails.location : '' : '';
						}
					}
				}
			})
		} else {
			this.data = null;
		}

	}
	ngOnChanges() {
		// if (this.data && this.data.trainerObj.jobRoles) {
		// 	for (let i = 0; i < this.data.trainerObj.jobRoles.length; i++) {
		// 		this.qpCode = this.jobRole.name ? this.jobRole.name.qpCode : this.jobRole.qpCode
		// 		if (this.data.trainerObj.jobRoles[i].jobRoleId === this.qpCode && this.data.trainerObj.jobRoles[i].isCertified === true) {
		// 			this.isCertified = this.data.trainerObj.jobRoles[i].isCertified === true ? 'Yes' : 'No';
		// 			this.downloadLink = this.data.trainerObj.jobRoles[i].certificateDetails ?
		// 				this.data.trainerObj.jobRoles[i].certificateDetails.certificateURLDetails ?
		// 				this.data.trainerObj.jobRoles[i].certificateDetails.certificateURLDetails.location : '' : '';
		// 		}
		// 	}
		// }
	}
	downloadCertificate() {
		this.fileService.downloadAttachedFile(this.downloadLink);
	}
	isEntreprenerShipCertified(value) {
		if (value && value.isCertified === true) {
			return 'Yes';
		} else {
			return 'No';
		}
	}
	convertsMonthsToYears(months, type) {
		if (!months) {
			return 0
		}
		if (type == 'year') {
			return Math.floor(months / 12)
		} else {
			return months % 12
		}
	}
}

